import { render } from "./BaseNav.vue?vue&type=template&id=1e4ba756&scoped=true"
import script from "./BaseNav.vue?vue&type=script&lang=js"
export * from "./BaseNav.vue?vue&type=script&lang=js"

import "./BaseNav.vue?vue&type=style&index=0&id=1e4ba756&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-1e4ba756"

export default script